import { Outlet, useLocation,useNavigate } from 'react-router-dom';

import config from '@/config';
import useCache from '@/hooks/useCache';
import useGoBack from '@/hooks/useGoBack';
import useStateHandler from '@/hooks/useStateHandler';
import ProfileOptionsPageHeader from '@/shared-components/navigation/ProfileOptionsPageHeader';

import './styles/Orders.css';

export default function Orders() {
  const goBackHandler = useGoBack("/profile");
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useStateHandler();
  const orderType = state?.user_session?.user_type === 'gallery' ? 'seller' : 'buyer';
  const { fetchData: unreadSummary } = useCache(
    `${state?.user_session?._id}_order_message_summary`,
    `${config.apis.api.url}/orders/unread-message-summary`,
    {
      injectToken: true,
      expiresIn: ['30', 'seconds'],
      invalidateWhen: ['ORDER_MESSAGES_READ'],
      includeSearchQueries: { type: orderType },
    }
  );
  const unreadOrdersFor = (status) => Number(unreadSummary?.data?.[status]?.unreadOrderCount) || 0;

  return (
    <>
      <div className="orders-layout__page">
        <div className="orders-layout__wrapper">
          <ProfileOptionsPageHeader title="Orders" onBack={goBackHandler} />

          <div className="orders-layout__outter-nav">
            <nav className={`orders-layout__nav element-non-selectable ${location.pathname === "/orders/sent" ? "sent" : location.pathname === "/orders/completed" ? "completed" : "confirmed"}`}>
              <span className="orders-layout__link confirmed" onClick={()=>navigate("/orders/confirmed", { replace: true })}>
                                Confirmed
                {unreadOrdersFor('confirmed') > 0 ? <span className="orders-layout__unread-count">{unreadOrdersFor('confirmed')}</span> : null}
              </span>

              <span className="orders-layout__link sent" onClick={()=>navigate("/orders/sent", { replace: true })}>
                                Sent
                {unreadOrdersFor('sent') > 0 ? <span className="orders-layout__unread-count">{unreadOrdersFor('sent')}</span> : null}
              </span>

              <span className="orders-layout__link completed" onClick={()=>navigate("/orders/completed", { replace: true })}>
                                Completed
                {unreadOrdersFor('completed') > 0 ? <span className="orders-layout__unread-count">{unreadOrdersFor('completed')}</span> : null}
              </span>

              <div className="orders-layout__active-bar"/>
            </nav>
          </div>

          <div className="orders-layout__content">
            <Outlet/>
          </div>
        </div>
      </div>
    </>
  );
}
